<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.4692 18C6.87668 18 8.28398 17.4574 9.34579 16.3971L11.2963 14.4489C11.8641 13.8817 11.8641 12.9445 11.2963 12.3526C10.7284 11.7854 9.79014 11.7854 9.19746 12.3526L7.24696 14.3008C6.2594 15.2871 4.67918 15.2871 3.6914 14.3008C2.70385 13.3144 2.70385 11.736 3.6914 10.7494L5.64191 8.80125C6.20976 8.23408 6.20976 7.29689 5.64191 6.70492C5.07406 6.13775 4.13575 6.13775 3.54308 6.70492L1.59257 8.65311C-0.530857 10.774 -0.530857 14.2513 1.59257 16.3969C2.6542 17.4574 4.06168 18 5.46916 18L5.4692 18Z"
    />
    <path
      d="M13.4197 11.7113C13.79 11.7113 14.1851 11.5633 14.4567 11.2675L16.4074 9.34368C18.5309 7.22277 18.5309 3.74548 16.4074 1.59992C14.284 -0.52098 10.8026 -0.545598 8.65444 1.59992L6.70393 3.5481C6.13608 4.11528 6.13608 5.05246 6.70393 5.64443C7.27178 6.2116 8.21008 6.2116 8.80276 5.64443L10.7533 3.69625C11.2224 3.22763 11.8643 2.95635 12.531 2.95635C13.1977 2.95635 13.8396 3.22764 14.3088 3.69625C15.2963 4.68263 15.2963 6.26097 14.3088 7.24757L12.3583 9.19575C11.7904 9.76292 11.7904 10.7001 12.3583 11.2921C12.6543 11.5632 13.0248 11.7113 13.4197 11.7113Z"
    />
    <path
      d="M7.41979 12.0565C7.79009 12.0565 8.18517 11.9086 8.45682 11.6127L11.6421 8.45586C12.2099 7.88868 12.2099 6.9515 11.6421 6.35953C11.0742 5.79236 10.1359 5.79236 9.54323 6.35953L6.35817 9.54079C5.79032 10.108 5.79032 11.0452 6.35817 11.6371C6.65441 11.9332 7.02469 12.0565 7.41979 12.0565Z"
    />
  </svg>
</template>
